/**
 * Copyright (c) 2022 Wizart Animation.
 *
 * CONFIDENTIAL AND PROPRIETARY
 *
 * This work is provided "AS IS" and subject to the Prodtrack
 * Source Code License. By accessing, using, copying or modifying
 * this work you indicate your agreement to the Prodtrack Source Code License.
 * All rights not expressly granted therein are reserved by Wizart Animation.
 */

export const UPDATE_WD_COMMANDS = "UPDATE_WD_COMMANDS";
export const UPDATE_SCHEMA = "UPDATE_SCHEMA";
export const UPDATE_PROJECT_SCHEMA = "UPDATE_PROJECT_SCHEMA";
export const UPDATE_PERMISSIONS = "UPDATE_PERMISSIONS";
export const NEW_UPDATE_PERMISSIONS = "NEW_UPDATE_PERMISSIONS";
export const CONTENT_TYPES = "CONTENT_TYPES";
export const USER_IS_AUTHENTICATED = "USER_IS_AUTHENTICATED";
export const SET_USERNAME = "SET_USERNAME";
export const SET_USERAVATAR = "SET_USERAVATAR";
export const SET_USER_FULLNAME = "SET_USER_FULLNAME";
export const SET_IS_FREELANCER = "SET_IS_FREELANCER";
export const SET_USER_IS_STAFF = "SET_USER_IS_STAFF";
export const SET_USER_IS_SUPERUSER = "SET_USER_IS_SUPERUSER";
export const SET_USER_ID = "SET_USER_ID";
export const SET_IS_SERIES = "SET_IS_SERIES";

export const SET_RAW_DATA = "SET_RAW_DATA";

export const SIDE_BAR_RIGHT_DETAIL_VIEW_SHOW =
    "SIDE_BAR_RIGHT_DETAIL_VIEW_SHOW";
export const SIDE_BAR_RIGHT_QUICK_FILTER_SHOW =
    "SIDE_BAR_RIGHT_QUICK_FILTER_SHOW";
export const QUICK_FILTER_APPLY = "QUICK_FILTER_APPLY";
export const SET_QUICK_FILTER_DATA = "SET_QUICK_FILTER_DATA";
export const SET_QUICK_FILTER = "SET_QUICK_FILTER";
export const SIDE_BAR_RIGHT_SHOW = "SIDE_BAR_RIGHT_SHOW";
export const SIDE_BAR_LEFT_SHOW = "SIDE_BAR_LEFT_SHOW";
export const SIDE_BAR_LEFT_WIDTH = "SIDE_BAR_LEFT_WIDTH";
export const SET_TASK_FILTER = "SET_TASK_FILTER";
export const SET_ENTITY_CONTEXT = "SET_ENTITY_CONTEXT";
export const SET_SELECTED_FILTER_ITEMS = "SET_SELECTED_FILTER_ITEMS";
export const SET_ENTITY_DISPLAY_NAMES = "SET_ENTITY_DISPLAY_NAMES";
export const SET_DEFAULT_UNIT_DURATION = "SET_DEFAULT_UNIT_DURATION";
export const SET_HOURS_WORK_DAY = "SET_HOURS_WORK_DAY";
export const SET_VERSION_REVIEW_ATTACHMENTS = "SET_VERSION_REVIEW_ATTACHMENTS";
export const SET_SELECTED_MARKER_ID = "SET_SELECTED_MARKER_ID";
export const SET_VIDEO_PLAYER_TIME_FORMAT = "SET_VIDEO_PLAYER_TIME_FORMAT";
export const SET_CUSTOM_CONTEXT_MENU_ITEMS = "SET_CUSTOM_CONTEXT_MENU_ITEMS";
export const SET_IS_DARK = "SET_IS_DARK";
export const FEATURE_FLAGS = "FEATURE_FLAGS";
export const SITE_PREFERENCES = "SITE_PREFERENCES";
export const DETAILVIEW_MODE_SIDEBAR_WIDTH = "DETAILVIEW_MODE_SIDEBAR_WIDTH";
export const NOTIFICATIONS_COUNTER = "NOTIFICATIONS_COUNTER";
export const CLOSE_NOTE_STATUS = "CLOSE_NOTE_STATUS";
export const CAN_DOWNLOAD_VIDEO = "CAN_DOWNLOAD_VIDEO";
